module.exports = __webpack_public_path__ + "static/img/lgchem-thumb.58a4498.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lgchem-thumb.jpg
// module id = +eeD
// module chunks = 0